<template>
  <div class="col-xs-12 col-sm-6">
    <div class="order-title-area-sty">
      <div class="order-main-title-sty">
        <h3>預約服務</h3>
      </div>
    </div>
    <OrderContent :dropDownObj="dropDownObj">
    </OrderContent>
  </div>
</template>
<script>
import OrderContent from './customer/OrderContent.vue'

const defaultDropdownObj = require('@/assets/columnsConfigs/oderColumn.json')
export default {
  name: 'CreateOrderList',
  data () {
    return {
      dropDownObj: defaultDropdownObj.data,
      userId: ''
    }
  },
  beforeMount () {
    this.getDropdownObj()
  },
  computed: {},
  methods: {
    getDropdownObj () {
      const self = this
      var isRecommenderClose = false
      this.$api.get(this.$apiDoc.apiGetOrderColumns, {}).then((resp) => {
        if (resp.result) {
          self.dropDownObj = resp.data
          console.log(self.dropDownObj)
          isRecommenderClose = self.dropDownObj.recommender_close === undefined ? isRecommenderClose : self.dropDownObj.recommender_close
          if (typeof isRecommenderClose !== 'boolean') {
            isRecommenderClose = JSON.parse(isRecommenderClose)
            if (typeof isRecommenderClose !== 'boolean') {
              isRecommenderClose = false
            }
          }
          self.dropDownObj.recommender_close = isRecommenderClose
        }
      }).catch((errorInfo) => {
        console.log('errorInfo:', errorInfo)
      })
    }
  },
  components: {
    OrderContent
  }
}
</script>
